import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";

// Components
import { ContactForm } from "./components/ContactForm";
import { BookingWizard } from "./components/BookingWizard";

// Vanilla bindings (PHP-rendered markup, no React mount)
import { initProfileForm } from "./profile-form";

// WordPress integration: Mount components to specific containers
const mountComponent = <P extends object>(
  containerId: string,
  Component: React.ComponentType<P>,
  props?: P,
) => {
  const container = document.getElementById(containerId);
  if (container) {
    // Get data attributes from container
    const dataProps = Object.entries(container.dataset).reduce(
      (acc, [key, value]) => {
        try {
          acc[key] = JSON.parse(value || "");
        } catch {
          acc[key] = value;
        }
        return acc;
      },
      {} as Record<string, unknown>,
    );

    try {
      ReactDOM.createRoot(container).render(
        <React.StrictMode>
          <Component {...(props || ({} as P))} {...(dataProps as P)} />
        </React.StrictMode>,
      );
    } catch (error) {
      console.error(`[React] Error mounting ${containerId}:`, error);
    }
  }
};

const init = () => {
  mountComponent("manosactivas-contact", ContactForm);
  mountComponent("manosactivas-booking-new", BookingWizard);
  initProfileForm();
};

// Mount components when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
